import React from 'react';
import { Link } from '@fluentui/react';
import { isUser } from 'app/utils/authUtilities';
import useStore, { IStore } from 'app/store';
import { useHistory } from 'react-router';
import { keyPress } from 'app/components/helpers';
import { appInsightsService, RouteConstants} from 'app/utils/constants';
import { UserDto } from 'generated/request-backend';
interface IProps {
    name: string;
    UnifiedTrackingId: string;
    inputString: string;
    setSearchText?: Function;
    handleSuggestionClose?: Function;
}

const FormattedSuggestion: React.FC<IProps> = (props) => {
    let parts: string[];
    try {
        parts = props.name ? props.name.split(new RegExp(`(${props.inputString})`, 'gi')) : [];
    } catch (error) {
        parts = [props.name];
    }
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails as UserDto);
    const searchOrigin = useStore((state: IStore) => state.searchOrigin);

    const history = useHistory();
    const getPageLink = () => {
        if (
            searchOrigin.includes('manage-requests') ||
            (!isUser(userDetails?.userRoles) && searchOrigin === '/') ||
            searchOrigin.includes('report') ||
            searchOrigin.includes('visual-flow')
        )
            return RouteConstants.REQUEST_DETAIL;
        else return RouteConstants.REQUEST;
    };
    const pageLink = isUser(userDetails?.userRoles) ? RouteConstants.REQUEST : getPageLink();
    const clickHandler = () => {
        history.push({
            pathname: `${pageLink}${props.UnifiedTrackingId}`,
            state: { previousPath: window.location.pathname }
        });
        props.setSearchText('');
        props.handleSuggestionClose();
        appInsightsService.logEvent(
            "SearchResultClick: clicked a search result", 
            {
                searchResultId: props.UnifiedTrackingId,
            });
    };
    return (
        <li>
            <Link tabIndex={0} onClick={clickHandler} onKeyPress={(e: React.KeyboardEvent<HTMLAnchorElement>) => keyPress(e, clickHandler)} data-testid="link-test">
                {props.UnifiedTrackingId} -{' '}
                {parts.map((part, idx: number) =>
                    part.toLowerCase() === props.inputString.toLowerCase() ? (
                        <b key={idx}>{part}</b>
                    ) : (
                        <span key={idx}>{part}</span>
                    )
                )}
            </Link>
        </li>
    );
};

export default FormattedSuggestion;
